<template>
  <div
    v-if="ride.video_url || ride.audio_url"
    class="ride-media-section"
  >
    <div v-if="ride.video_url" class="ride-media-item">
      <video
        controls
        preload="metadata"
        class="ride-media-video"
        :src="ride.video_url"
      >
        {{ t('videoTagNotSupported') }}
      </video>
    </div>
    <div v-if="ride.audio_url" class="ride-media-item">
      <audio
        controls
        class="ride-media-audio"
        :src="ride.audio_url"
      >
        {{ t('audioTagNotSupported') }}
      </audio>
    </div>
  </div>
</template>

<script>
import { translationMixin } from "@/mixins/translationMixin";

// The ride's own video and audio, when the manager uploaded them.
export default {
  name: 'RideMedia',
  mixins: [translationMixin],
  props: {
    ride: { type: Object, required: true },
  },
};
</script>

<style scoped>
.ride-media-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1rem 16px 0;
}

.ride-media-item {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1.5rem 0;
}

.ride-media-video {
  width: 100%;
  max-width: 560px;
  max-height: 360px;
  border-radius: 8px;
  background: #000;
}

.ride-media-audio {
  width: 100%;
  max-width: 560px;
  height: 40px;
}
</style>
